// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAvpUg4xmleHQlbFX4D-H5Yxt4OGdqCNj4",

    authDomain: "eron-settings.firebaseapp.com",
  
    databaseURL: "https://eron-settings-default-rtdb.europe-west1.firebasedatabase.app",
  
    projectId: "eron-settings",
  
    storageBucket: "eron-settings.appspot.com",
  
    messagingSenderId: "479432050275",
  
    appId: "1:479432050275:web:1b837a3facbc71c7101a56"
  
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
